(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name autoRosterSchedule.factory:AutoRosterScheduleRequestFactory
     *
     * @description
     *
     */
    angular
        .module('fuel')
        .factory('AutoRosterScheduleRequestFactory', AutoRosterScheduleRequestFactory);
    function AutoRosterScheduleRequestFactory() {

        function AutoScheduleSaveRequestTO() {
            this.fromDate = null;
            this.toDate = null;
            this.status = null;
            this.cycleId = null;
            this.crewTypeCodesList = null;
            this.airCraftTypes = null;
            this.crewBase = null;
            this.isDeleteBlock = null;
            this.isDistBlock = null;
            this.isDistStandby = null;
            this.isForceStandBy = 'N';
            this.isDistUnlimitedStandby = 'N';
            this.scheduleDate = null;
            this.scheduleTime = null;
            this.autoScheduleSetupId = null;
            this.changeStatusTo = null;
            this.version = -1;
            this.ignoreOverlap = false;
            this.ignorePeriodValid = false;
            this.distributionGroups = null;
            this.isDistDHD = null;
            this.isDistContractOff = null;
            this.isDelContractOff = null;
            this.isDistCalContractOff = null;
            this.isSelectCrews = null;
            this.crewProfileIdList = null;
            this.patternNameList = null;
            this.isDistributeStandbyConsideringFlights = null;
            this.standbyStrategyId = null;
        }

        function ChangeStatusAutoRosterRequestTO() {
            this.autoScheduleSetupId = null;
            this.version = null;
            this.status = null;
            this.changeStatusTo = null;
        }

        function AutoScheduleRequestTO() {
            this.fromDate = null;
            this.toDate = null;
            this.cycleId = null;
            //this.crewTypeCode=null;
            this.crewBase= null;
            this.airCraftTypes = null;
            this.crewTypeCodesList = null;
            this.pageSize = null;
            this.startPosition = null;
            this.distributionGroups = null;
        }

        function checkCSBRequestDTO() {
            this.autoScheduleSetupIdList = null;
        }

        function GetSaveAutoRosterScheduleRequest() {
            return new AutoScheduleSaveRequestTO();
        }

        function GetAutoRosterScheduleSearchRequest() {
            return new AutoScheduleRequestTO();
        }

        function GetAutoRosterScheduleStatusChangeReq() {
            return new ChangeStatusAutoRosterRequestTO();
        }

        function GetAutoRosterScheduleCheckCSBReq() {
            return new checkCSBRequestDTO();
        }

        return {
            getAutoRosterScheduleSearchRequest : GetAutoRosterScheduleSearchRequest,
            getSaveAutoRosterScheduleRequest: GetSaveAutoRosterScheduleRequest,
            getAutoRosterScheduleStatusChangeReq: GetAutoRosterScheduleStatusChangeReq,
            getAutoRosterScheduleCheckCSBReq: GetAutoRosterScheduleCheckCSBReq
        }

    }
})();
